export default __webpack_public_path__ + "static/huyen-3d34fa764ed4d411928857a6281c6a5a.png";